import { lazy } from "react";

const Payflow_Payouts = lazy(() => import("@/pages/Payflow/Payouts/index"));
const Payflow_Reports = lazy(() => import("@/pages/Payflow/Reports/index"));
const Payflow_Settings = lazy(() => import("@/pages/Payflow/Settings/index"));
const Payflow_EmployeeBanks = lazy(() => import("@/pages/Payflow/EmployeeBanks/index"));
const Payflow_EmployeeSalaries = lazy(() => import("@/pages/Payflow/EmployeeSalaries/index"));
const Payflow_EmployeeDeductions = lazy(() => import("@/pages/Payflow/EmployeeDeductions/index"));
const Payflow_Deductions_List = lazy(() => import("@/pages/Payflow/EmployeeDeductions/DeductionList"));
const Payflow_EmployeeLoans = lazy(() => import("@/pages/Payflow/EmployeeLoans/index"));
const Payflow_Loans_List = lazy(() => import("@/pages/Payflow/EmployeeLoans/LoanList"));
const Payflow_EmployeeIncomes = lazy(() => import("@/pages/Payflow/EmployeeIncomes/index"));
const Payflow_Incomes_List = lazy(() => import("@/pages/Payflow/EmployeeIncomes/IncomeList"));
const Payflow_BankConfigurations = lazy(() => import("@/pages/Payflow/BankConfigurations/index"));
const Payflow_BankTransmittals = lazy(() => import("@/pages/Payflow/BankTransmittals/index"));
const Payflow_DeductionTypes = lazy(() => import("@/pages/Payflow/DeductionTypes/index"));
const Payflow_IncomeTypes = lazy(() => import("@/pages/Payflow/IncomeTypes/index"));
const Payflow_PayrollGroups = lazy(() => import("@/pages/Payflow/PayrollGroups/index"));
const Payflow_PayrollPeriods = lazy(() => import("@/pages/Payflow/PayrollPeriods/index"));

export var payflowRoutes = [
    { path: "/payflow/payouts", component: <Payflow_Payouts /> },
    { path: "/payflow/deductions", component: <Payflow_EmployeeDeductions /> },
    { path: "/payflow/deductions/list", component: <Payflow_Deductions_List /> },
    { path: "/payflow/employee-banks", component: <Payflow_EmployeeBanks /> },
    { path: "/payflow/employee-salaries", component: <Payflow_EmployeeSalaries /> },
    { path: "/payflow/loans", component: <Payflow_EmployeeLoans /> },
    { path: "/payflow/loans/list", component: <Payflow_Loans_List /> },
    { path: "/payflow/incomes", component: <Payflow_EmployeeIncomes /> },
    { path: "/payflow/incomes/list", component: <Payflow_Incomes_List /> },
    { path: "/payflow/settings", component: <Payflow_Settings /> },
    { path: "/payflow/settings/payrollPeriods", component: <Payflow_PayrollPeriods /> },
    { path: "/payflow/settings/payrollGroups", component: <Payflow_PayrollGroups /> },
    { path: "/payflow/settings/deductionTypes", component: <Payflow_DeductionTypes /> },
    { path: "/payflow/settings/incomeTypes", component: <Payflow_IncomeTypes /> },
    { path: "/payflow/settings/bankConfigurations", component: <Payflow_BankConfigurations /> },
    { path: "/payflow/bank-transmittals", component: <Payflow_BankTransmittals /> },
    { path: "/payflow/reports", component: <Payflow_Reports /> },
];